import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default (onType, fragment) => {
  const { gql, useQuery } = useAppContext();

  const NodeQuery = gql`
query ($gid: ID!) {
  node(gid: $gid) {
    id
    ...${onType}
  }
}
${fragment}
  `;

  const NodesQuery = gql`
query ($gids: [ID!]!) {
  nodes(gids: $gids) {
    id
    ...${onType}
  }
}  
${fragment}
  `;

  const useNodeQuery = (gid) => useQuery(NodeQuery, {
    variables: { gid },
    fetchPolicy: 'network-only',
  });

  const useNodesQuery = (gids) => useQuery(NodesQuery, {
    variables: { gids },
    fetchPolicy: 'network-only',
  });

  return {
    useNodeQuery,
    useNodesQuery,
  };
};
